export default __webpack_public_path__ + "static/media/clipboard-text.055383b6.svg";